import React, { useState, useCallback } from 'react'
import { styled } from '@linaria/react'
import { colors } from '../styles/colors'
import Close from '../svgr/Close'
import { ImageUploader } from '../ui/ImageUploader'

interface UploadImageButtonProps {
  onImageSelect?: (imageUrl: string) => void
  onImageRemove?: () => void
  className?: string
  folder?: string
}

export const UploadImageButton: React.FC<UploadImageButtonProps> = ({
  onImageSelect,
  onImageRemove,
  className,
  folder = 'boxes',
}) => {
  const [uploadedUrl, setUploadedUrl] = useState<string | null>(null)

  const handleUploadSuccess = useCallback(
    (url: string) => {
      setUploadedUrl(url)
      onImageSelect?.(url)
    },
    [onImageSelect],
  )

  const handleRemoveImage = useCallback(() => {
    setUploadedUrl(null)
    onImageRemove?.()
  }, [onImageRemove])

  if (uploadedUrl) {
    return (
      <ImagePreviewContainer className={className}>
        <PreviewImage src={uploadedUrl} alt="Выбранное изображение" />
        <RemoveButton onClick={handleRemoveImage}>
          <Close />
        </RemoveButton>
      </ImagePreviewContainer>
    )
  }

  return (
    <UploaderContainer className={className}>
      <ImageUploader onUploadSuccess={handleUploadSuccess} folder={folder} />
    </UploaderContainer>
  )
}

const UploaderContainer = styled.div`
  width: 100%;
`

const ImagePreviewContainer = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  max-width: 100%;
  height: 200px;
`

const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

const RemoveButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${colors.shadowLight};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: ${colors.shadowDark};
  }

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: white;
    }
  }
`
